// import React, { createContext, useState } from 'react';

// const UsersContext = useContext({
//   isReset: false,
// });

// export default UsersContext;
import React, { createContext, useState } from 'react';

const UsersContext = createContext();

const UsersProvider = ({ children }) => {
  const [resetUsers, setRefreshUserlist] = useState(false);
  const [filterIsOpened, setFilterIsOpened] = useState(false);
  const [lastSavedSelections, setFilterSelections] = useState({
    clientIds: [],
    superClientIds: [],
    adminIds: [],
    vendorIds:"",
    vendorName:"",
    userStatusActive :false,
    userStatusInactive: false
  });


  const deleteUser = (userId) => {
    // const updatedUsers = users.filter((user) => user !== userId);
    setRefreshUserlist(!resetUsers);
  };

  return (
    <UsersContext.Provider value={{ resetUsers, setRefreshUserlist, deleteUser , setFilterSelections, lastSavedSelections, filterIsOpened, setFilterIsOpened}}>
      {children}
    </UsersContext.Provider>
  );
};

export { UsersContext, UsersProvider };
